const COOKIE_NAME = "pl_pending_remix";
const COOKIE_DOMAIN = ".promptlayer.com";

export interface PendingRemix {
  share_token: string;
}

const isLocalhost = (): boolean => {
  const { hostname } = window.location;
  return hostname === "localhost" || hostname === "127.0.0.1";
};

const getCookieAttributes = (): string => {
  if (isLocalhost()) {
    // On localhost, omit Domain entirely. Browsers reject "Domain=localhost"
    // because it lacks an embedded dot (RFC 6265). Without an explicit Domain,
    // the cookie becomes "host-only" for localhost — and since cookies are NOT
    // port-scoped, it will be sent to all localhost ports (3000, 5173, 8000, etc.).
    return "Path=/; SameSite=Lax";
  }
  return `Domain=${COOKIE_DOMAIN}; Path=/; Secure; SameSite=Lax`;
};

/**
 * Reads and immediately clears the pending remix cookie.
 * Returns null if no pending remix exists or the cookie is malformed.
 */
export function readAndClearPendingRemix(): PendingRemix | null {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  if (!match) {
    return null;
  }

  // Clear the cookie immediately to prevent re-processing
  document.cookie = `${COOKIE_NAME}=; ${getCookieAttributes()}; Max-Age=0`;

  try {
    return JSON.parse(decodeURIComponent(match[1])) as PendingRemix;
  } catch {
    return null;
  }
}

/**
 * Check if a pending remix cookie exists without consuming it.
 * Used by the new-user flow to decide whether to auto-remix.
 */
export function hasPendingRemix(): boolean {
  return document.cookie.includes(`${COOKIE_NAME}=`);
}
